import {
	EventDispatcher,
	Matrix4,
	Plane,
	Raycaster,
	Vector2,
	Vector3,
    Quaternion
} from 'three';
import { ThreeView } from '../View3dWebCad';
import {RayIntersection} from '../Octree/RayIntersection';

const _plane = new Plane();
const _raycaster = new Raycaster();

const _pointer = new Vector2();
const _offset = new Vector3();
const _intersection = new Vector3();
const _worldPosition = new Vector3();
const _inverseMatrix = new Matrix4();
const _pointStart = new Vector3();
const _positionStart = new Vector3();

const _rayWall = new Raycaster();

let _ClientRect = null;
let _height = 0;
let _width = 0;

class IconWallItemDragControls extends EventDispatcher {

	constructor( _objects, _camera, _domElement ) {

		super();

		_domElement.style.touchAction = 'none'; // disable touch scroll

		let _selected = null, _hovered = null;

		const _intersections = [];

		//

		const scope = this;

		function activate() {

			_domElement.addEventListener( 'pointermove', onPointerMove );
			_domElement.addEventListener( 'pointerdown', onPointerDown );
			_domElement.addEventListener( 'pointerup', onPointerCancel );
			_domElement.addEventListener( 'pointerleave', onPointerCancel );

		}

		function deactivate() {

			_domElement.removeEventListener( 'pointermove', onPointerMove );
			_domElement.removeEventListener( 'pointerdown', onPointerDown );
			_domElement.removeEventListener( 'pointerup', onPointerCancel );
			_domElement.removeEventListener( 'pointerleave', onPointerCancel );

			_domElement.style.cursor = '';

		}

		function dispose() {

			deactivate();

		}

		function getObjects() {

			return _objects;

		}

		function getRaycaster() {

			return _raycaster;

		}

		function onPointerMove( event ) {

			if ( scope.enabled === false ) return;

			updatePointer( event );

			_raycaster.setFromCamera( _pointer, _camera );

			if ( _selected ) {

				// 壁アイテム
				// const objects = ThreeView.get().wcItemmgr.floorsObjects.getObjects("L" + String(ThreeView.get().wcCameras.floor));
				// _rayWall.setFromCamera( _pointer, _camera );
				// const intersectObjects = _rayWall.intersectObjects( objects, true );
				
				_rayWall.setFromCamera(_pointer, ThreeView.get().wcCameras.camera.me);
				const intersections = new RayIntersection(_rayWall);
				const intersectObjects = intersections.getTargets_(ThreeView.get().CameraTarget.box3Status);

				if (intersectObjects.length > 0) {
					for (let i = 0; i < intersectObjects.length; i ++) {
						if (intersectObjects[i].object && intersectObjects[i].object.userData.type && (intersectObjects[i].object.userData.type == 'KABE' || intersectObjects[i].object.userData.type == 'KOSI')) {
							// 壁の法線ベクトル
							const normal = intersectObjects[i].face.normal;

							// 形状の正のz軸ベクトル
							const ObjZAxis = _selected.getWorldDirection(new Vector3()).normalize();

							// 回転角rad取得
							const rad = ObjZAxis.angleTo(normal);

							// 回転軸を取得
							const axisRotation = ObjZAxis.cross(normal).normalize();
							if (axisRotation.length() < 0.01) {
								axisRotation.copy(new Vector3(0, 1, 0));
							}

							// 配置オブジェクトのQuaternionを取得
							const quaternion = _selected.quaternion;

							// 回転させるためのQuaternionを作成
							const target = new Quaternion();
							target.setFromAxisAngle(axisRotation, rad);

							// 配置オブジェクトの回転
							quaternion.multiply(target.clone());

							_offset.applyQuaternion(target.clone());

							// 形状配置計算
							const pos = intersectObjects[i].point;

							if (_selected.userData.modelInfo.type == 'pin') {
								const offsetPin = normal.multiplyScalar(0.05);
								_selected.position.copy(pos.clone().add(offsetPin));
							} else {
								_selected.position.copy(pos.clone().sub(_offset))
							}

							break;
						}

						if (_selected.uuid == getTarget(intersectObjects[i].object)?.uuid) {
							continue;
						} else {
							_selected.position.copy(_positionStart);
							_selected.position.applyMatrix4( _inverseMatrix );
							break;
						}
					}
				}

				scope.dispatchEvent( { type: 'drag', object: _selected } );

				return;

			}

			// hover support

			if ( event.pointerType === 'mouse' || event.pointerType === 'pen' ) {
					
				if (event.clientX > _ClientRect.x && event.clientY > _ClientRect.y && 
					_ClientRect.x + _width > event.clientX && _ClientRect.y + _height > event.clientY) {

                    const object = getTarget(_objects[0]);

					if ( _hovered !== object && _hovered !== null ) {

						scope.dispatchEvent( { type: 'hoveroff', object: _hovered } );

						_domElement.style.cursor = 'auto';
						_hovered = null;

					}

					if ( _hovered !== object ) {

						scope.dispatchEvent( { type: 'hoveron', object: object } );

						_domElement.style.cursor = 'pointer';
						_hovered = object;

					}

				} else {

					if ( _hovered !== null ) {

						scope.dispatchEvent( { type: 'hoveroff', object: _hovered } );

						_domElement.style.cursor = 'auto';
						_hovered = null;

					}

				}

			}

		}
		
		// 対象オブジェクトを取得
		function getTarget( object ) {
			if (object == null) return;
			const index = _objects.findIndex((obj) => obj.uuid == object.uuid);
			if (index <= -1)  return getTarget(object.parent);
			return _objects[index];
		}

		function onPointerDown( event ) {

			if ( scope.enabled === false ) return;

			updatePointer( event );
				
			if (event.clientX > _ClientRect.x && event.clientY > _ClientRect.y && 
				_ClientRect.x + _width > event.clientX && _ClientRect.y + _height > event.clientY) {
				
				_selected = getTarget(_objects[0]);

				_positionStart.copy(_worldPosition.setFromMatrixPosition( _selected.matrixWorld ));
				_pointStart.copy(_pointer);

				// 壁アイテム
				// const objects = ThreeView.get().wcItemmgr.floorsObjects.getObjects("L" + String(ThreeView.get().wcCameras.floor));
				// _rayWall.setFromCamera( _pointer, _camera );
				// const intersectObjects = _rayWall.intersectObjects( objects, true );
				
				_rayWall.setFromCamera(_pointer, ThreeView.get().wcCameras.camera.me);
				const intersections = new RayIntersection(_rayWall);
				const intersectObjects = intersections.getTargets_(ThreeView.get().CameraTarget.box3Status);

				if (intersectObjects.length > 0) {
					for (let i = 0; i < intersectObjects.length; i ++) {
						if (intersectObjects[i].object && intersectObjects[i].object.userData.type && (intersectObjects[i].object.userData.type == 'KABE' || intersectObjects[i].object.userData.type == 'KOSI')) {
							
							const pickerRay = intersectObjects[i].point.sub(_rayWall.ray.origin);
							const positionRay = _selected.getWorldPosition(new Vector3()).sub(_rayWall.ray.origin);
							_offset.copy(pickerRay.sub(positionRay));

							break;
						}
					}
				}

				_domElement.style.cursor = 'move';

				scope.dispatchEvent( { type: 'dragstart', object: _selected } );

			}


		}

		function onPointerCancel() {

			if ( scope.enabled === false ) return;

			if ( _selected ) {

				scope.dispatchEvent( { type: 'dragend', object: _selected } );

				_selected = null;

			}

			_domElement.style.cursor = _hovered ? 'pointer' : 'auto';

		}

		function updatePointer( event ) {

			const rect = _domElement.getBoundingClientRect();

			_pointer.x = ( event.clientX - rect.left ) / rect.width * 2 - 1;
			_pointer.y = - ( event.clientY - rect.top ) / rect.height * 2 + 1;

		}
		
		// picker位置設定
		function setPicker(ClientRect, height, width) {
			_ClientRect = ClientRect; 
			_height = height; 
			_width = width; 

			return this;
		}


		activate();

		// API

		this.enabled = true;
		this.transformGroup = false;

		this.activate = activate;
		this.deactivate = deactivate;
		this.dispose = dispose;
		this.getObjects = getObjects;
		this.getRaycaster = getRaycaster;
		
		this.setPicker = setPicker;

	}

}

export { IconWallItemDragControls };
